import { pick } from 'ramda';
import { useEffect } from 'react';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import * as helpers from '../helpers';

export const useStoreGuestId = () => {
    const app = useAppSelector(pick(['pgg2', 'cookiesConfiguration']));
    const user = useUserSelector(pick(['guestId']));

    useEffect(() => {
        helpers.saveGuestIdToStorage({ app, user });
    }, [app, user]);
};
